import { createContext, ReactNode, useContext } from "react";

import { useFilterPackageTransport } from "./filter-package-transport.hook";

const FilterPackageTransportContext = createContext(
  {} as ReturnType<typeof useFilterPackageTransport>
);
export function useFilterPackageTransportContext() {
  return useContext(FilterPackageTransportContext);
}

interface FilterPackageTransportProviderProps {
  children: ReactNode;
}
export function FilterPackageTransportProvider({
  children,
}: FilterPackageTransportProviderProps) {
  return (
    <FilterPackageTransportContext.Provider value={useFilterPackageTransport()}>
      {children}
    </FilterPackageTransportContext.Provider>
  );
}